module.exports = __webpack_public_path__ + "img/EmissionTracker-dark.eec5ad8d.svg";